import React from "react";
function Counters({ counter, label, styleData, style }) {
 const uniquelabel = [...new Set(label)]
	return (
		<>
			<div className={styleData} style={{ maxWidth: "80%", overflow: "auto" }}>
				{uniquelabel.map((item) => {
					return (
						<div className="count-container" key={item}>
							<div className={`counter ${item}`}>
								{item}{" "}
								<span className={`count ${item}-count`}>
									{counter[`${item}`]}
								</span>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
}

export default Counters;
